import { useRequiredContext } from "@redotech/react-util/context";
import { useLoad } from "@redotech/react-util/load";
import { RedoOutboundLabelsRpcClientContext } from "@redotech/redo-merchant-fulfillment-app/outbound-labels-rpc-client";
import { SetReturnAddressActionStep } from "@redotech/redo-model/advanced-flow/oms/actions";
import { FulfillmentOrderAddressWithId } from "@redotech/redo-model/fulfillments/fulfillment-order-address";
import { RedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";
import { RedoSingleSelectDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-single-select-dropdown-input";
import { memo, useMemo } from "react";
import { PartialWithRequiredType } from ".";

export const ReturnAddressDropdown = memo(function ReturnAddressDropdown({
  step,
  setStep,
}: {
  step: PartialWithRequiredType<SetReturnAddressActionStep>;
  setStep: (step: PartialWithRequiredType<SetReturnAddressActionStep>) => void;
}) {
  const rpcClient = useRequiredContext(RedoOutboundLabelsRpcClientContext);

  const returnAddressLoad = useLoad(async () => {
    try {
      const { addresses } = await rpcClient.getReturnAddresses(null);
      return addresses;
    } catch (error) {
      console.error(error);
      return [];
    }
  }, []);

  const listItems: RedoListItem<FulfillmentOrderAddressWithId>[] =
    useMemo(() => {
      return (
        returnAddressLoad.value?.map((address) => ({
          id: address._id,
          value: address,
          type: "text",
          text: address.name,
        })) || []
      );
    }, [returnAddressLoad.value]);

  return (
    <RedoSingleSelectDropdownInput
      options={listItems}
      optionSelected={(option) =>
        setStep({ ...step, address: option.item.value })
      }
      selectedItem={listItems.find((item) => item.id === step.address?._id)}
    />
  );
});
